import { clone } from 'lodash'

export default {
  name: 'DialogMixin',
  data() {
    return {
      show: false
    }
  },
  methods: {
    open(model) {
      this.model = clone(model)
      this.show = true
    },
    close() {
     // this.$emit('close')
      this.show = false
      
    },
    saved() {
      var copy = clone(this.model)
      this.$emit('saved', copy)
      this.show = false
    }
  }
}
